import ScrollToTop from "../../components/ScrollToTop.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import WorthToKnowSectionComponent from "../../components/alternative-frontpages/WorthToKnowSectionComponent.tsx";
import WhatYouAreGettingSectionComponent from "../../components/alternative-frontpages/WhatYouAreGettingSectionComponent.tsx";
import WhyChooseHiperSectionComponent from "../../components/alternative-frontpages/WhyChooseHiperSectionComponent.tsx";
import CallMeRTOComponent from "../../components/callMe/CallMeRTOComponent.tsx";
import TjekBredbaandHeroComponent from "../../components/hero/TjekBredbaandHeroComponent.tsx";
import setNoIndexMeta from "../../components/setNoIndexMeta.tsx";
import AlternativeFrontpagesTitleAndMetaDescription from "../../components/alternative-frontpages/AlternativeFrontpagesTitleAndMetaDescription.tsx";

export default function TjekBredbaandPage() {
    ScrollToTop()
    useDatalayer()
    setNoIndexMeta()
    AlternativeFrontpagesTitleAndMetaDescription()

    /* utm_source=1167664433 */

    return (
        <div className={"page-campaign-ida"}>
            <TjekBredbaandHeroComponent/>
            <CallMeRTOComponent className={"rto--box page-home"}/>
            <WhatYouAreGettingSectionComponent/>
            <WorthToKnowSectionComponent/>
            <WhyChooseHiperSectionComponent/>
        </div>
    )
}
